/*
 * Utils to manage aria attributes in UI-Kit components props
 */
import { filterObjectByKey } from "./objectTools";

/**
 * Get all aria attributes of component props
 *
 * @param props Original props
 * @return {Object} Just props starting by 'aria-'
 */
export var getAriaAttributes = function getAriaAttributes(props) {
  return filterObjectByKey(props, /^aria-/);
};